import {
  Alert,
  Breadcrumb,
  Button,
  Card,
  Col,
  DatePicker,
  Empty,
  Form,
  Icon,
  Input,
  message,
  Modal,
  Pagination,
  Row,
  Table,
  Upload,
} from 'antd';
import { RangePickerValue } from 'antd/lib/date-picker/interface';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import Column from 'antd/lib/table/Column';
import { UploadFile } from 'antd/lib/upload/interface';
import gql from 'graphql-tag';
import * as moment from 'moment';
import queryString from 'query-string';
import React, { Component, FormEvent } from 'react';
import { Mutation, Query } from 'react-apollo';
import { Link, RouteComponentProps } from 'react-router-dom';
import { DateRange, PageInfo } from 'src/types/base';
import styled from 'styled-components';
import * as xlsx from 'xlsx';

import { Panel } from '../../components/Panel';
import { ChangedSku } from './type';

const UploadReminder = styled.div`
  width: 100%;
  padding: 10px;
  height: 40px;
  font-size: 20px;
  color: red;
`;

const skuListQuery = gql`
  query getSkuListQuery($name: String, $startRange: DateRange, $take: Int, $skip: Int, $after: ID, $before: ID) {
    skusConnection(name: $name, startRange: $startRange, take: $take, skip: $skip, after: $after, before: $before) {
      nodes {
        id
        name
        start
        end
        availableFrom
        availableUntil
        price
        soldStock
        totalStock
        course {
          id
          name
        }
      }
      pageInfo {
        totalCount
        startCursor
        endCursor
      }
    }
  }
`;
const createBetaEnrollmentMutation = gql`
  mutation createBetaEnrollment($id: ID, $mobile: String) {
    createBetaEnrollment(id: $id, mobile: $mobile) {
      id
      user {
        id
        mobile
      }
    }
  }
`;

const createBetaEnrollmentsMutation = gql`
  mutation createBetaEnrollments($skuId: ID, $mobiles: [String]) {
    createBetaEnrollments(id: $skuId, mobiles: $mobiles)
  }
`;

interface SkuListData {
  skusConnection: { nodes: ChangedSku[]; pageInfo: PageInfo };
}
interface SkuListStates {
  isInputGroupNameModalDisplay: boolean;
  inputUserMobile: string;
  isInputMobileMessageAlert: boolean;
  currentSkuId?: number;
  pageSize: number;
  currentPage: number;
  skuName?: string;
  skuStartEndRange?: DateRange;
  variables: {
    name?: string;
    startRange?: DateRange;
    take: number;
    skip?: number;
    before?: number;
    after?: number;
  };
  fileList: UploadFile[];
  mobiles: string[];
  isShowBatchAddBetaEnrollmentsModal: boolean;
  selectedSku?: ChangedSku;
}

interface Props {
  form: WrappedFormUtils;
}
const SKUS_COUNT_PER_PAGE = 50;
type SkuListProps = RouteComponentProps<{ id: string }> & Props;
export class StockListForm extends Component<SkuListProps, SkuListStates> {
  constructor(props: SkuListProps) {
    super(props);
    this.state = {
      isInputGroupNameModalDisplay: false,
      inputUserMobile: '',
      isInputMobileMessageAlert: false,
      pageSize: 50,
      currentPage: 1,
      variables: {
        skip: 0,
        take: SKUS_COUNT_PER_PAGE,
      },
      fileList: [],
      mobiles: [],
      isShowBatchAddBetaEnrollmentsModal: false,
    };
    this.showAddListModal = this.showAddListModal.bind(this);
    this.handleAddListModalCancel = this.handleAddListModalCancel.bind(this);
    this.onResetClick = this.onResetClick.bind(this);
  }

  async componentDidMount() {
    const {
      location: { search },
    } = this.props;
    const { pageIndex } = queryString.parse(search);
    if (pageIndex) {
      this.setState({
        currentPage: Number(pageIndex),
      });
    }
  }
  showAddListModal(id: number) {
    this.setState({
      currentSkuId: id,
      isInputGroupNameModalDisplay: true,
    });
  }
  onResetClick() {
    this.props.form.resetFields();
  }
  handleAddListModalCancel = () => {
    this.setState({
      inputUserMobile: '',
      isInputMobileMessageAlert: false,
      isInputGroupNameModalDisplay: false,
    });
  };

  search = (e: FormEvent) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        message.error(err);
        return;
      }
      const dates =
        values.skuStartEndRange && values.skuStartEndRange.length > 1
          ? {
              from: moment(values.skuStartEndRange[0]).startOf('day').toDate(),
              to: moment(values.skuStartEndRange[1]).endOf('day').toDate(),
            }
          : undefined;
      const variables = {
        name: values.skuName,
        startRange: dates,
        take: SKUS_COUNT_PER_PAGE,
        skip: 0,
      };
      this.setState({
        variables,
        skuName: values.skuName,
        skuStartEndRange: values.skuStartEndRange,
        currentPage: 1,
      });
    });
  };

  downloadTemplateFile = () => {
    const excelList: {
      mobile?: string;
    }[] = [];
    for (let i = 1; i <= 100; i += 1) {
      const dateObj = { mobile: '' };
      excelList.push(dateObj);
    }
    const workbook = xlsx.utils.book_new();
    const sheet1 = xlsx.utils.json_to_sheet(excelList);
    xlsx.utils.book_append_sheet(workbook, sheet1);
    xlsx.writeFile(workbook, '批量添加白名单模版.xlsx');
  };

  showBatchAddBetaEnrollmentsModal = (id: number, selectedSku: ChangedSku) => {
    this.setState({ selectedSku, currentSkuId: id, isShowBatchAddBetaEnrollmentsModal: true });
  };

  hideBatchAddBetaEnrollmentsModal = () => {
    this.setState({ isShowBatchAddBetaEnrollmentsModal: false, fileList: [], mobiles: [] });
  };

  batchAddBetaEnrollments = () => {
    const uploadprops = {
      beforeUpload: (file: UploadFile | Blob) => {
        const oneFile = file as UploadFile;
        if (oneFile.status !== 'removed') {
          const fileList = [oneFile];
          const reader = new FileReader();
          const blob = file as Blob;
          reader.readAsBinaryString(blob);
          reader.onload = (event: any) => {
            const data = event.target.result;
            const workbook = xlsx.read(data, {
              type: 'binary',
            });

            const sheetName = workbook.SheetNames[workbook.SheetNames.length - 1];
            if (!sheetName) {
              return;
            }

            const mobileObjList: { mobile: number }[] = xlsx.utils.sheet_to_json(workbook.Sheets[sheetName]) || [];
            const mobileList = mobileObjList.reduce((accumulator, currentValue) => {
              const { mobile } = currentValue;
              if (/^\d{11}$/g.test(String(mobile))) {
                accumulator.push(String(mobile));
              }
              return accumulator;
            }, [] as string[]);

            const mobileMap = new Map();
            for (const mobile of mobileList) {
              if (mobile) {
                mobileMap.set(mobile, mobile);
              }
            }
            const mobiles = Array.from(mobileMap.values());

            this.setState({ mobiles, fileList });
          };
        }
        return false;
      },
      onRemove: () => {
        this.setState({ fileList: [], mobiles: [] });
      },
    };
    const { currentSkuId, mobiles, fileList, selectedSku } = this.state;
    const moblesData = mobiles.map((mobile, index) => {
      return { mobile, id: index + 1 };
    });
    return (
      <Mutation
        mutation={createBetaEnrollmentsMutation}
        variables={{ mobiles, skuId: currentSkuId }}
        refetchQueries={[{ query: skuListQuery, variables: this.state.variables }]}
      >
        {(createBetaEnrollments, { loading }) => {
          return (
            <Modal
              title="批量添加白名单"
              confirmLoading={loading}
              visible={this.state.isShowBatchAddBetaEnrollmentsModal}
              onOk={async () => {
                try {
                  if (fileList.length === 0) {
                    message.error('请导入文件！');
                    return;
                  }
                  if (mobiles.length === 0) {
                    message.error('请下载导入模版，填写正确的手机号！');
                    return;
                  }

                  if (selectedSku && mobiles.length + Number(selectedSku.soldStock) > Number(selectedSku.totalStock)) {
                    message.error('导入的白名单数与已售卖数量和超出库存总量！');
                    return;
                  }

                  await createBetaEnrollments();
                  message.success('添加成功！');
                  this.setState({ isShowBatchAddBetaEnrollmentsModal: false, fileList: [], mobiles: [] });
                } catch (error) {
                  message.error('添加失败！');
                }
              }}
              onCancel={this.hideBatchAddBetaEnrollmentsModal}
            >
              <Upload {...uploadprops} accept=".xls, .xlsx" fileList={fileList}>
                <Button>
                  <Icon type="upload" /> 选择文件
                </Button>
              </Upload>
              {mobiles.length ? (
                <Table
                  dataSource={moblesData}
                  rowKey={record => `${record.id}`}
                  title={() => {
                    return <>预览: 共导入{mobiles.length}个白名单</>;
                  }}
                  size="small"
                  pagination={moblesData.length <= 5 ? false : { pageSize: 5 }}
                >
                  <Table.Column title="id" dataIndex="id" key="id" width="50%" />
                  <Table.Column title="mobile" dataIndex="mobile" key="mobile" width="50%" />
                </Table>
              ) : (
                fileList.length !== 0 && <UploadReminder>选择的文件中没有正确的手机号！</UploadReminder>
              )}
            </Modal>
          );
        }}
      </Mutation>
    );
  };

  render() {
    const { skuName, skuStartEndRange, currentPage, variables } = this.state;
    const { getFieldDecorator } = this.props.form;
    return (
      <>
        <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
          <Breadcrumb.Item>
            <Link to={`/Home`}>首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>库存管理</Breadcrumb.Item>
        </Breadcrumb>
        <Card>
          <h2>SKU信息</h2>
          <Form layout="inline" onSubmit={this.search}>
            <Row gutter={24} type={'flex'} align={'middle'}>
              <Col span={8}>
                <Form.Item label={`商品名称:`}>
                  {getFieldDecorator('skuName')(<Input style={{ width: '300px' }} allowClear />)}
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item label={`开课时间:`}>
                  {getFieldDecorator('skuStartEndRange')(<DatePicker.RangePicker />)}
                </Form.Item>
              </Col>

              <Col span={8}>
                <Button style={{ marginRight: 8 }} type="primary" onClick={this.downloadTemplateFile}>
                  下载白名单导入模板
                </Button>
                <Button icon="search" type="primary" htmlType="submit" style={{ marginRight: 8 }}>
                  搜索
                </Button>
                <Button>
                  <Link to={`/stock/create`}>新增</Link>
                </Button>
              </Col>
            </Row>
          </Form>
        </Card>
        <Query<SkuListData> query={skuListQuery} variables={this.state.variables} fetchPolicy="cache-and-network">
          {({ loading, error, data }) => {
            if (error) return <div>{error.message}</div>;
            if (loading) return <div>loading...</div>;
            if (!data) {
              // @ts-ignore
              return <Empty />;
            }
            const skusConnection = (data && data.skusConnection) || [];
            const { nodes: skus } = skusConnection;
            const { currentSkuId, inputUserMobile, isInputGroupNameModalDisplay } = this.state;
            for (let i = 0, len = skus.length; i < len; i += 1) {
              const startLocalTime = moment.utc(skus[i].start).toDate();
              const startFormatTime = moment(startLocalTime).format('YYYY/MM/DD');
              const endLocalTime = moment.utc(skus[i].end).toDate();
              const endFormatTime = moment(endLocalTime).format('YYYY/MM/DD');
              skus[i].startEnd = `${startFormatTime}~${endFormatTime}`;
              const availableFromLocalTime = moment.utc(skus[i].availableFrom).toDate();
              const availableFromFormatTime = moment(availableFromLocalTime).format('YYYY/MM/DD');
              const availableUntilLocalTime = moment.utc(skus[i].availableUntil).toDate();
              const availableUntilFormatTime = moment(availableUntilLocalTime).format('YYYY/MM/DD');
              skus[i].vailableFromTo = `${availableFromFormatTime}~${availableUntilFormatTime}`;
            }
            const { getFieldDecorator } = this.props.form;
            return (
              <>
                <Panel style={{ padding: 24, display: 'none' }}>
                  <Form layout="inline">
                    <Row gutter={16}>
                      <Col span={8}>
                        <Form.Item label="群名称">
                          <Input allowClear />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item label="SKU">
                          <Input allowClear />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item label="状态">
                          <Input allowClear />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form>
                  <Row style={{ marginTop: 8 }}>
                    <Col span={24} style={{ textAlign: 'right' }}>
                      <Button style={{ marginRight: 8 }} type="primary" onClick={this.onResetClick}>
                        重置
                      </Button>
                      <Button type="primary" htmlType="submit">
                        搜索
                      </Button>
                      <Button style={{ marginLeft: 8 }}>清空</Button>
                    </Col>
                  </Row>
                </Panel>
                <Panel style={{ marginTop: 16 }}>
                  <Table
                    pagination={false}
                    dataSource={skus}
                    rowKey={record => `${record.id}`}
                    footer={() => (
                      <Pagination
                        style={{ float: 'right', marginBottom: 16 }}
                        total={skusConnection.pageInfo.totalCount}
                        pageSize={variables.take}
                        current={currentPage}
                        onChange={nextPage => {
                          const pageSkip = (Math.abs(nextPage - currentPage) - 1) * SKUS_COUNT_PER_PAGE;

                          if (nextPage > currentPage) {
                            this.setState({
                              variables: {
                                name: skuName,
                                startRange: skuStartEndRange,
                                skip: pageSkip,
                                take: SKUS_COUNT_PER_PAGE,
                                after: skusConnection.pageInfo.endCursor,
                              },
                            });
                          }
                          if (nextPage < currentPage) {
                            this.setState({
                              variables: {
                                name: skuName,
                                startRange: skuStartEndRange,
                                skip: pageSkip,
                                take: SKUS_COUNT_PER_PAGE,
                                before: skusConnection.pageInfo.startCursor,
                              },
                            });
                          }
                          this.setState({
                            currentPage: nextPage,
                          });
                        }}
                      />
                    )}
                  >
                    <Table.Column title="ID" dataIndex="id" key="id" width="5%" />
                    <Table.Column title="商品名" dataIndex="name" />
                    <Table.Column title="课程名" dataIndex="course.name" />
                    <Table.Column title="单价" dataIndex="price" key="price" />
                    <Table.Column<ChangedSku>
                      title="sku有效时间"
                      dataIndex="startEnd"
                      sorter={(a, b) => {
                        return moment(a.start).valueOf() - moment(b.start).valueOf();
                      }}
                    />
                    <Table.Column<ChangedSku> title="售卖时间" dataIndex="vailableFromTo" />
                    <Table.Column title="已售卖" dataIndex="soldStock" key="soldStock" />
                    <Table.Column title="总量" dataIndex="totalStock" key="totalStock" />
                    <Table.Column
                      title="操作"
                      key="sku.id"
                      // dataIndex="id"
                      render={row => (
                        <>
                          <Button
                            onClick={() => this.showAddListModal(row.id)}
                            style={{ marginRight: 3, marginBottom: 3 }}
                          >
                            添加白名单
                          </Button>
                          <Button
                            style={{ marginRight: 3, marginBottom: 3 }}
                            onClick={() => this.showBatchAddBetaEnrollmentsModal(row.id, row)}
                          >
                            批量添加白名单
                          </Button>
                          <Button style={{ marginRight: 3, marginBottom: 3 }}>
                            <Link to={`/stock/${row.id}/update`}>更新</Link>
                          </Button>
                          <Button>
                            <Link to={`/stock/${row.id}/schedules/course/${row.course.id}`}>设置课程</Link>
                          </Button>
                        </>
                      )}
                    />
                  </Table>
                </Panel>
                <div>{this.batchAddBetaEnrollments()}</div>
                <Mutation
                  mutation={createBetaEnrollmentMutation}
                  variables={{ id: currentSkuId, mobile: inputUserMobile }}
                >
                  {createBetaEnrollment => {
                    return (
                      <Modal
                        closable={false}
                        visible={isInputGroupNameModalDisplay}
                        onOk={async () => {
                          this.props.form.validateFields(async (err, values) => {
                            if (err) {
                              message.error(err);
                              return;
                            }
                            this.setState(
                              {
                                isInputMobileMessageAlert: false,
                                isInputGroupNameModalDisplay: false,
                                inputUserMobile: values.inputUserMobile,
                              },
                              async () => {
                                try {
                                  await createBetaEnrollment();
                                  message.success('添加成功');
                                } catch {
                                  message.error('添加失败');
                                }
                              },
                            );
                          });
                        }}
                        onCancel={this.handleAddListModalCancel}
                      >
                        <Form>
                          <Form.Item label="手机号">
                            {getFieldDecorator('inputUserMobile')(
                              <Input maxLength={50} placeholder="请输入手机号" allowClear />,
                            )}
                          </Form.Item>
                        </Form>
                        {this.state.isInputMobileMessageAlert ? (
                          <Alert message="请输入正确的手机号" type="error" />
                        ) : null}
                      </Modal>
                    );
                  }}
                </Mutation>
              </>
            );
          }}
        </Query>
      </>
    );
  }
}
export const StockList = Form.create({ name: 'StockList' })(StockListForm);



// WEBPACK FOOTER //
// ./src/screens/stock/StockList.tsx